import { AccessPermissions } from '@circlefin/permissions'
import { Role } from '@circlefin/permissions/roles'
import { SynthRole } from '@services/synthetic-roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Permissions for guarding Convert features.
 */
export const CONVERT_SECTION: PermissionSet = {
  access: AccessPermissions.protected,
  includeAll: [
    Role.USDC_WALLET_ROLE,
    Role.EURC_WALLET_ROLE,
    Role.EXCHANGE_ROLE,
    SynthRole.SYNTH_SWAP_ENABLE_ROLE,
  ],
  excludeAny: [SynthRole.SYNTH_FX_CENTER_ROLE],
}
